export enum StatusProgramId {
  Cluster = 'be0b92d6-359d-4f33-b338-f2fd1e0b6941',
  OneWayIn = '47c9c132-3a89-4c7c-ba3f-f726697b949e',
  Siva = 'e5b03377-5a16-4e2a-8e2b-0352b23c3ebc',
}
